import { get } from "lodash";
import { AUTHENTICATION } from "../authentication/authenticationConstants.js";
import {
  API_RESET,
  API_SUCCESS,
  API_ERROR,
  API_ERROR_MODAL,
  API_ERROR_NEXT,
  API_ERROR_RESET
} from "../../actions/actionConstants.js";

export const INITIAL = {
  isError: false,
  isFatal: false,
  showError: false,
  errors: [],
  errorMessages: [],
  violationErrors: [],
  successes: []
};

export const apiReducer = (state = INITIAL, action = {}) => {
  const errors = state.errors ? state.errors.slice() : null;
  const errorMessages = state.errorMessages
    ? state.errorMessages.slice()
    : null;
  const violationErrors = state.violationErrors
    ? state.violationErrors.slice()
    : null;

  const error = get(action, "payload.error", null);

  switch (action.type) {
    case API_ERROR:
      // store error Response
      errors.push(error);

      const json = get(action, "payload.json", null);
      const requestAction = get(action, "payload.action", null);
      const isFatal = get(action, "payload.isFatal", false);

      // store a derived error message.
      if (json) {
        if (json["@type"] === "ConstraintViolation") {
          const fieldPath = get(requestAction, "payload.fieldPath", null);
          if (fieldPath && fieldPath !== "") {
            const fieldPathViolations = json.violations.map(item => {
              if (requestAction.payload.fieldPath) {
                item.propertyPath = `${requestAction.payload.fieldPath}.${item.propertyPath}`;
              }
              return item;
            });
            violationErrors.push(fieldPathViolations);
          } else {
            violationErrors.push(json.violations);
          }
        }
        errorMessages.push({
          title: json["hydra:title"],
          message: json["hydra:description"],
          status: error.status,
          statusText: error.statusText,
          requestAction,
          isFatal
        });
      } else {
        errorMessages.push({
          title: error.status,
          message: error.statusText,
          status: error.status,
          statusText: error.statusText,
          requestAction,
          isFatal
        });
      }

      return {
        ...state,
        errors,
        errorMessages,
        violationErrors,
        isError: true
      };

    case API_ERROR_NEXT:
      // remove current error
      errors.shift();
      errorMessages.shift();
      violationErrors.shift();

      // if there are no errors left, reset the store
      if (errors.length < 1) {
        return INITIAL;
      }

      return {
        ...state,
        errors,
        errorMessages,
        violationErrors
      };

    case API_ERROR_MODAL:
      return {
        ...state,
        showError: true
      };

    case API_SUCCESS:
      const successes = state.successes ? state.successes.slice() : null;

      // store error Response
      successes.push(action.payload);

      return {
        ...state,
        successes
      };

    case API_RESET:
    case API_ERROR_RESET:
    case AUTHENTICATION.LOGOUT.DO:
      return INITIAL;

    default:
      return state;
  }
};

export default {};
